import { memo, useCallback } from 'react';

import { type SelectProps } from '~/components/Select/Select';
import { SingleSelect } from '~/components/Select/SingleSelect';
import { type DateRangeType } from '~/store/filters/types';

type DateTypeOption = {
  value: DateRangeType;
  label: string;
};

export const dateTypeOptions: DateTypeOption[] = [
  { value: 'today', label: 'Today' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: 'last-week', label: 'Last week' },
  { value: 'last-month', label: 'Last month' },
  { value: 'last-year', label: 'Last year' },
  { value: 'custom-range', label: 'Custom date range' },
];

export type DateFilterTypeSelectProps = {
  selectedType: DateRangeType;
  onTypeChange: (type: DateRangeType) => void;
  className?: string;
};

export const DateFilterTypeSelect = memo(({ selectedType, onTypeChange, className }: DateFilterTypeSelectProps) => {
  const onSelectionChange: SelectProps<DateTypeOption>['onSelectionChange'] = useCallback(
    ({ chips }) => {
      onTypeChange(chips[chips.length - 1].value);
    },
    [onTypeChange],
  );

  const selectedDate = dateTypeOptions.find((option) => option.value === selectedType);

  return (
    <SingleSelect
      size="large"
      options={dateTypeOptions}
      selectedOption={selectedDate}
      onSelectionChange={onSelectionChange}
      placeholder="Select date..."
      className={className}
    />
  );
});

DateFilterTypeSelect.displayName = 'DateFilterTypeSelect';
